// Simple mobile accordion for footer
(function() {
  'use strict';

  // Check if the current viewport is mobile
  function isMobileView() {
    return window.innerWidth < 750;
  }

  // Initialize the accordion
  function initFooterAccordion() {
    // Get all footer menu blocks
    const menuBlocks = document.querySelectorAll('.footer-block--menu');
    if (!menuBlocks.length) return;

    // Process each menu block
    menuBlocks.forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      const menu = block.querySelector('.footer-block__details-content');
      
      if (!heading || !menu) return;

      // Only initialize once
      if (heading.dataset.accordionInitialized === 'true') return;

      // Add toggle button if it doesn't exist
      if (!heading.querySelector('.accordion-toggle')) {
        const toggle = document.createElement('span');
        toggle.className = 'accordion-toggle';
        toggle.textContent = '+';
        heading.appendChild(toggle);
      }

      // Set initial state
      updateMenuState(menu, heading, isMobileView());
      
      // Add click handler
      heading.addEventListener('click', function(e) {
        // Don't toggle if clicking a link
        if (e.target.tagName === 'A' || e.target.closest('a')) return;
        e.preventDefault();
        e.stopPropagation();
        
        const isHidden = menu.style.display === 'none' || !menu.style.display;
        menu.style.display = isHidden ? 'block' : 'none';
        const toggle = heading.querySelector('.accordion-toggle');
        if (toggle) {
          toggle.textContent = isHidden ? '–' : '+';
        }
      });

      // Mark as initialized
      heading.dataset.accordionInitialized = 'true';
    });
  }

  // Update menu state based on viewport
  function updateMenuState(menu, heading, isMobile) {
    if (!menu || !heading) return;
    
    const toggle = heading.querySelector('.accordion-toggle');
    
    if (isMobile) {
      // Mobile view
      menu.style.display = 'none';
      heading.style.cursor = 'pointer';
      heading.style.position = 'relative';
      heading.style.paddingRight = '25px';
      if (toggle) toggle.style.display = 'inline-block';
    } else {
      // Desktop view - show all menus
      menu.style.display = '';
      heading.style.cursor = '';
      heading.style.position = '';
      heading.style.paddingRight = '';
      if (toggle) toggle.style.display = 'none';
    }
  }

  // Handle window resize
  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const isMobile = isMobileView();
      document.querySelectorAll('.footer-block--menu').forEach(block => {
        const menu = block.querySelector('.footer-block__details-content');
        const heading = block.querySelector('.footer-block__heading');
        updateMenuState(menu, heading, isMobile);
      });
    }, 100);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initFooterAccordion();
      window.addEventListener('resize', handleResize, { passive: true });
    });
  } else {
    initFooterAccordion();
    window.addEventListener('resize', handleResize, { passive: true });
  }
})();
